/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-named-as-default */
import React from 'react';
import {
  useTable,
  useSortBy,
} from 'react-table';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import {
  Table, TableHead, TableRow, TableBody, TableCell,
} from '@mui/material';
import './_tableStyles.scss';
import type { ITableProps } from 'formsTypes';

export default function CustomTable(props: ITableProps): JSX.Element {
  const {
    columns,
    data,
    onRowClick,
    selectedRowId,
    getRowClassName,
  } = props;
  const {
    getTableProps,
    headerGroups,
    rows,
    prepareRow,
    getTableBodyProps,
  } = useTable({ columns, data }, useSortBy);

  return (
    <div className='custom-table-wrapper'>
      <Table {...getTableProps()}>
        <TableHead>
          {headerGroups.map((headerGroup) => (
            <TableRow {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => {
                const columnAsAny = column as unknown as Record<string, unknown>;
                return (
                  <TableCell
                    className={`ct-header-cell${typeof columnAsAny.className === 'string' && columnAsAny.className !== '' ? ` ${columnAsAny.className}` : ''}`}
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    style={{ width: column.width }}
                  >
                    <div className='header-content'>
                      {column.render('Header')}
                      {column.Header !== '' && !columnAsAny.disableSortBy && (
                        <span>
                          {column.isSorted && column.isSortedDesc !== true ? (
                            <ArrowUpwardIcon
                              className='sort-icon'
                              htmlColor='#66788A'
                              fontSize='small'
                              style={{
                                width: '1rem',
                                height: '1rem',
                                margin: '0 4px',
                              }}
                            />
                          ) : (
                            <ArrowDownwardIcon
                              className='sort-icon'
                              htmlColor='#66788A'
                              fontSize='small'
                              style={{
                                width: '1rem',
                                height: '1rem',
                                margin: '0 4px',
                              }}
                            />
                          )}
                        </span>
                      )}
                    </div>
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableHead>
        <TableBody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            const isSelected = selectedRowId !== undefined && (row.original as Record<string, unknown>).id === selectedRowId;
            const customRowClassName = getRowClassName ? getRowClassName(row.original) : '';
            return (
              <TableRow
                className={`ct-table-body-row${isSelected ? ' selected-row' : ''}${customRowClassName ? ` ${customRowClassName}` : ''}`}
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...row.getRowProps()}
                onClick={(): void => {
                  if (onRowClick) {
                    onRowClick(row.original);
                  }
                }}
              >
                {row.cells.map((cell) => {
                  const cellColumnAsAny = cell.column as unknown as Record<string, unknown>;
                  return (
                    <TableCell
                      className={`ct-body-cell${typeof cellColumnAsAny.className === 'string' && cellColumnAsAny.className !== '' ? ` ${cellColumnAsAny.className}` : ''}`}
                      // eslint-disable-next-line react/jsx-props-no-spreading
                      {...cell.getCellProps()}
                      style={{
                        width: cell.column.width,
                        ...(cellColumnAsAny.cellStyle as Record<string, unknown>),
                      }}
                    >
                      {cell.render('Cell')}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>

    </div>
  );
}
